import { useLocation, useNavigate } from "react-router-dom";
import AccountInfo from "../AccountInfo";
import { useContext, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "../Studio/ProgressBar";
import { Context } from "../contexts/AppContext";
import { getData } from "../../lib/utils";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  const menuRef = useRef(null);

  const { progress } = useContext(Context);
  const { files = [] } = progress;

  const showMenuButton =
    !location.pathname.includes("vidflix-superadmin/clientdata");

  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  // ---------------- FETCH ADMIN ----------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData("admin/admin-details");
        setAppState((prev) => ({
          ...prev,
          adminDetails: response.admin,
        }));
      } catch (error) {
        console.error("Error fetching admin details:", error);
      }
    };
    fetchData();
  }, []);

  // ---------------- MENU ----------------
  const openMenuHandler = () => setIsMenuOpen(true);

  const superAmdinLogOut = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ---------------- PROGRESS ----------------
  const handleCancel = (uniqueId) => {
    progress.stopProgressBarById(uniqueId);
  };

  const totalProgress =
    files.reduce((sum, f) => sum + f.percentage, 0) / files.length || 0;

  // ---------------- UI ----------------
  return (
    <>
      {/* ================= HEADER ================= */}
      <div
        className="flex justify-between items-center px-3 bg-white text-white  border-gray-700 relative"
        style={{ zIndex: 9999999 }}
      >
        <img src="/img/logo.png" alt="logo" className="w-[180px] py-1" />
        <div className="flex gap-4 items-center">
        <div className="text-black font-bold ">Total Uploaded Photo:{appState?.adminDetails?.photoCount}</div>
        {showMenuButton ? (
          <div
            onClick={openMenuHandler}
            className="bg-gray-800 w-10 h-10 flex items-center justify-center rounded-full cursor-pointer"
          >
            <FontAwesomeIcon icon="fa-solid fa-user" />
          </div>
        ) : (
          <button
            onClick={superAmdinLogOut}
            className="bg-gray-800 px-4 py-2 rounded cursor-pointer"
          >
            Log Out
          </button>
        )}
</div>
        {isMenuOpen && showMenuButton && (
          <div className="absolute right-2 top-14" ref={menuRef}>
            <AccountInfo />
          </div>
        )}
      </div>

      {/* ================= UPLOAD PROGRESS ================= */}
      {files.length > 0 && (
        <>
          {/* TOGGLE BUTTON */}
          <button
            onClick={() => setIsMinimized((prev) => !prev)}
            className="fixed bottom-2 right-4 z-20 
                       bg-gray-900 text-white w-10 h-10 
                       flex items-center justify-center 
                       rounded-full shadow-lg hover:bg-gray-800
                       transition"
            title={isMinimized ? "Expand uploads" : "Minimize uploads"}
          >
            <FontAwesomeIcon
              icon={faChevronUp}
              className={`transition-transform duration-300 ${
                isMinimized ? "rotate-180" : ""
              }`}
            />
          </button>

          {/* PROGRESS CONTAINER */}
          <div
            className={`fixed bottom-12 right-4 z-10 w-[460px]
              bg-gray-800 rounded-xl shadow-xl
              transition-all duration-300
              ${isMinimized ? "h-14 overflow-hidden" : "max-h-[420px] overflow-y-auto"}
              flex flex-col gap-2 p-2`}
          >
            {/* MINIMIZED VIEW */}
            {isMinimized && (
              <div className="flex items-center justify-between px-3 py-2 text-white text-sm">
                <span>Uploading {files.length} file(s)</span>
                <span className="text-xs text-gray-300">
                  {Math.round(totalProgress)}%
                </span>
              </div>
            )}

            {/* EXPANDED VIEW */}
            {!isMinimized &&
              files.map((f) => (
                <div
                  key={f.uniqueId}
                  className="border border-gray-700 bg-gray-700 rounded-lg  "
                >
                  <ProgressBar
                    fileName={f.fileName}
                    prgBarVal={f.percentage}
                    onCancel={() => handleCancel(f.uniqueId)}
                    txt={f.txt}
                  />
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
}

export default Header;
